import { isNil } from 'lodash';

export class Percentiler {
  distribution: number[]; // Sorted

  constructor(rawDistribution: number[]) {
    this.distribution = [...rawDistribution].sort((a, b) => a - b);
  }

  getPercentile(value: number) {
    const rightIndex = findLastLessOrEqual(this.distribution, value);
    const leftIndex = findLastLessOrEqual(this.distribution, value - 0.0000001);

    if (isNil(rightIndex) || isNil(leftIndex)) {
      return NaN;
    }

    const fullCount = leftIndex + 1;
    const halfCount = rightIndex - leftIndex;
    const totalCount = fullCount + 0.5 * halfCount;

    return Math.round(totalCount) / this.distribution.length;
  }

  /**
   * Find a value corresponding to given percentile (0 <= p <= 1) from the distribution.
   * Does linear interpolation, so the number is not generally drawn from the distribution directly.
   */
  findPercentile(percentile: number) {
    if (percentile <= 0) return this.distribution[0];
    if (percentile >= 1) return this.distribution[this.distribution.length - 1];

    const index = (this.distribution.length - 1) * percentile;
    const lower = Math.floor(index);
    const upper = lower + 1;
    const weight = index % 1; // How much weight is left for the following value
    if (upper >= this.distribution.length) return this.distribution[lower];
    return this.distribution[lower] * (1 - weight) + this.distribution[upper] * weight;
  }
}

/**
 * Find the maximum index of element e so that e <= value
 * Binary search, assumes that array is presorted
 */
export function findLastLessOrEqual(array: number[], value: number) {
  if (array.length === 0) {
    return undefined;
  }

  let low = 0;
  let high = array.length - 1;
  let result = -1;

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);

    if (array[mid] <= value) {
      result = mid;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }

  return result;
}
